module.exports = __webpack_public_path__ + "img/saas_04.517426cb.jpg";